module.exports = __webpack_public_path__ + "static/media/home.6f9e4900.png";